import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { Device, Tag } from "../../interfaces/EndpointInterfaces";
import { Role, UserVerification } from "../interface";


export const fetchPendingUsers = async (tenantName: string): Promise<UserVerification[]> => {
    const url = `${NGROK}/api/invite/pending?tenantName=${tenantName}`;
    const data = await apiClient<UserVerification[]>({
        method: "GET",
        url,
    });
    return data;
}


export const fetchAllRoles = async (tenantName: string): Promise<Role[]> => {
    const url = `${NGROK}/api/${tenantName}/role-details`;
    const data = await apiClient<Role[]>({
        method: "GET",
        url,
    });
    return data;
}
export const fetchAllDevices = async (tenantName: string): Promise<Device[]> => {
    const url = `${NGROK}/api/${tenantName}/getAllUserMachines`;
    const data = await apiClient<Device[]>({
        method: "GET",
        url,
    });
    return data;
}

export const getTags = async (searchTags: string): Promise<Tag[]> => {
    let url = `${NGROK}/api/tags`;

    if (searchTags.length > 0) {
        url += `/search?q=${encodeURIComponent(searchTags)}&page=0&size=15`;
    } else {
        url += `/all?page=0&size=15`;
    }

    const response = await apiClient<{ content: Tag[] }>({
        method: "GET",
        url,
    });

    return response.content;
};

export const sentInvite = async (payload: any) => {
    let url = `${NGROK}/api/invite/send`
    const response = await apiClient({
        method: "POST",
        url,
        data: payload
    });
    return response;
}
